import NiceSelect from 'nice-select2';
import '../../../node_modules/nice-select2/dist/css/nice-select2.css';
import keyboardFocus from 'keyboard-focus';

keyboardFocus(document);

function addingAsterisk() {
  const requiredLabels = document.querySelectorAll('.js-form-type-checkbox label.js-form-required, .js-form-type-radio label.js-form-required');
  if (!requiredLabels.length > 0) return;
  requiredLabels.forEach((item) => {
    if (item.querySelector('span.asterisk')) return;
    const asterisk = document.createElement('span');
    asterisk.innerText = '*';
    asterisk.classList.add('asterisk');
    item.appendChild(asterisk);
  });
}

function initNiceSelects() {
  const selects = document.querySelectorAll('select:not(.nice-select-initialized):not([multiple="multiple"]):not(.notranslate)');

  if (!selects.length > 0) return;

  selects.forEach((select) => {
    const customSelect = new NiceSelect(select);
    select.classList.add('nice-select-initialized');

    const niceSelectElement = customSelect.dropdown;

    if (niceSelectElement) {
      const listElement = niceSelectElement.querySelector('.list');

      if (listElement) {
        listElement.setAttribute('tabindex', '-1');
      }

      niceSelectElement.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
          setTimeout(() => {
            const focusedOption = niceSelectElement.querySelector('.focus');
            if (focusedOption) {
              focusedOption.scrollIntoView({ block: 'nearest' });
            }
          }, 10);
        }
      });
    }
  });
}



(function (Drupal, $) {
  Drupal.behaviors.niceSelect = {
    attach(context) {
      'use strict';
      $(once('processed', 'body')).each(function () {
        addingAsterisk();
        initNiceSelects();
        initMultiSelectCheckboxDropdown();
        floatingLabel();
        document.dispatchEvent(new Event('niceSelectInitializeEnded'));

        $(document).ajaxComplete(() => {
          addingAsterisk();
          initNiceSelects();
          initMultiSelectCheckboxDropdown();
          floatingLabel();
        });
      });
    },
  };
})(Drupal, jQuery);




function initMultiSelectCheckboxDropdown() {
  jQuery('select[multiple]').multiSelect({
    noneText: 'Select',
  });

  const multiSelectContainers = document.querySelectorAll('.multi-select-container');

  if (!multiSelectContainers.length > 0) {
    return;
  }

  multiSelectContainers.forEach((multiSelectContainer) => {
    const selectMenuItemInputs = multiSelectContainer.querySelectorAll('.multi-select-menuitem > input[type="checkbox"]');
    const multiSelectButton = multiSelectContainer.querySelector('.multi-select-button');
    const multiSelectMenu = multiSelectContainer.querySelector('.multi-select-menu');
    const parent = multiSelectContainer.closest('.form-type-select');

    // Create a closure to maintain state for this specific dropdown
    const dropdownState = {
      selectedCount: 0,
      firstSelectedText: ''
    };

    parent.classList.add('multi-select-checkbox-dropdown');

    const updateSelectedState = () => {
      if (dropdownState.selectedCount > 0) {
        parent.classList.add('has-selected');
      } else {
        parent.classList.remove('has-selected');
      }
    };

    selectMenuItemInputs.forEach((input) => {
      if (input.checked) {
        dropdownState.selectedCount += 1;
        if (dropdownState.selectedCount === 1) {
          dropdownState.firstSelectedText = input.parentElement.textContent.trim();
        }
      }
    });

    updateSelectedState();

    if (dropdownState.selectedCount > 1) {
      multiSelectButton.innerText = `${dropdownState.firstSelectedText}, + ${dropdownState.selectedCount - 1} more`;
    }

    // Handle dropdown open/close state
    multiSelectButton.addEventListener('click', () => {
      const isOpen = multiSelectContainer.classList.contains('multi-select-container--open');
      
      if (isOpen) {
        parent.classList.add('is-open');
      } else {
        parent.classList.remove('is-open');
      }
    });

    document.addEventListener('click', (e) => {
      if (!multiSelectContainer.contains(e.target)) {
        parent.classList.remove('is-open');
      }
    });

    multiSelectContainer.addEventListener('click', (e) => {
      e.stopPropagation();
    });

    if (selectMenuItemInputs.length > 0) {
      selectMenuItemInputs.forEach((input) => {
        input.addEventListener('change', () => {
          dropdownState.selectedCount = 0;
          dropdownState.firstSelectedText = '';

          selectMenuItemInputs.forEach((inp) => {
            if (inp.checked) {
              dropdownState.selectedCount += 1;
              if (dropdownState.selectedCount === 1) {
                dropdownState.firstSelectedText = inp.parentElement.textContent.trim();
              }
            }
          });

          if (input.checked) {
            input.parentElement.classList.add('checked');
          } else {
            input.parentElement.classList.remove('checked');
          }

          updateSelectedState();

          if (dropdownState.selectedCount > 1) {
            multiSelectButton.innerText = `${dropdownState.firstSelectedText}, + ${dropdownState.selectedCount - 1} more`;
          } else if (dropdownState.selectedCount === 1) {
            multiSelectButton.innerText = dropdownState.firstSelectedText;
          } else {
            multiSelectButton.innerText = 'Select';
          }
        });
      });
    }
    

  });
}


function floatingLabel() {
  const inputs = document.querySelectorAll('input[type="text"], input[type="email"], input[type="password"], textarea');


  if (!inputs.length > 0) return;

  inputs.forEach((input) => {
    if (input.value.length > 0 || input.getAttribute('autofocus') === 'autofocus') {
      input.parentElement.classList.add('focused');
    }

    input.addEventListener('focus', (e) => {
      input.parentElement.classList.add('focused');
    });

    input.addEventListener('blur', (e) => {
      if (input.value.length > 0) return;
      input.parentElement.classList.remove('focused');
    });
  });
}


(function ($) {
  $(document).ready(function () {
    var activeInput = null;

    // Track the input that triggered autocomplete
    $(document).on('focus', 'input.ui-autocomplete-input', function () {
      activeInput = $(this);
    });

    // When autocomplete opens, match its width to the input field
    $(document).on('autocompleteopen', function () {
      if (activeInput) {
        
        $('.ui-autocomplete').css({
          width: activeInput.outerWidth() + 'px',
          left: activeInput.offset().left + 'px',
          top: activeInput.offset().top + activeInput.outerHeight() + 'px',
          boxSizing: 'border-box'
        });
      }
    });
  });
})(jQuery);
